// src/components/tasks/ObjectivePicker.tsx
// Goal 關聯選擇器 - 供 TaskDetail 選擇 active objective

import React from 'react';
import { Flag } from 'lucide-react';
import { LocalObjective } from '../../services/indexedDB';
import PickerShell from '../common/PickerShell';

interface ObjectivePickerProps {
  objectives: LocalObjective[];
  currentObjectiveId?: string;
  onSelect: (objectiveId: string | null) => void;
  onClose: () => void;
}

const ObjectivePicker: React.FC<ObjectivePickerProps> = ({
  objectives,
  currentObjectiveId,
  onSelect,
  onClose,
}) => {
  const handleSelect = (objectiveId: string | null) => {
    onSelect(objectiveId);
    onClose();
  };

  return (
    <PickerShell onClose={onClose}>
      <div className="px-2 py-3">
        {/* No Goal 選項 */}
        <button
          onClick={() => handleSelect(null)}
          className={`
            w-full flex items-center gap-3 px-3 py-2.5 text-sm text-left
            rounded-xl border-2 transition-colors
            ${!currentObjectiveId
              ? 'bg-sky-50 text-sky-700 border-sky-200 font-medium'
              : 'text-gray-500 border-transparent hover:bg-gray-50'
            }
          `}
        >
          <span className="w-4 h-4 shrink-0" />
          <span>No Goal</span>
        </button>

        {/* Active objectives */}
        {objectives.map((objective) => {
          const isSelected = currentObjectiveId === objective.id;
          return (
            <button
              key={objective.id}
              onClick={() => handleSelect(objective.id)}
              className={`
                w-full flex items-center gap-3 px-3 py-2.5 text-sm text-left
                rounded-xl border-2 transition-colors
                ${isSelected
                  ? 'bg-sky-50 text-sky-700 border-sky-200 font-medium'
                  : 'text-gray-700 border-transparent hover:bg-gray-50'
                }
              `}
            >
              <Flag
                className={`w-4 h-4 shrink-0 ${isSelected ? 'text-sky-500' : 'text-gray-400'}`}
              />
              <span className="truncate">{objective.title}</span>
            </button>
          );
        })}
      </div>
    </PickerShell>
  );
};

export default ObjectivePicker;
